import babyKids from './babyKids';
import juniorKids from './juniorKids';
import men from './men';
import women from './women';

export { babyKids, juniorKids, men, women };
